import React, { useEffect, useState, useContext } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  CardMedia,
  TextField,
  Dialog,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { UserContext } from "../context/UserContext"; // Adjust the path as needed
import bannerpic from "../Assests/Images/home.jpeg";
import aboutImage from "../Assests/Images/aboutus.png";
import img2 from "../Assests/Images/jobhome.jpg";
import img1 from "../Assests/Images/adshome.jpg";
import img5 from "../Assests/Images/classifiedhome.jpg";
import img3 from "../Assests/Images/eventhome.PNG";
import img6 from "../Assests/Images/serviceshome1.png";
import img4 from "../Assests/Images/offershome.png";
import pdfFile from "../Assests/Images/CITYZOOM.pdf";
import evolve from "../Assests/Images/evolvexinnovationsposter.png";
import tracker from "../Assests/Images/evolvextrackerposter.png";
import easybid from "../Assests/Images/EasyBidPoster.png";
import API_BASE_URL from "../../src/config";

const Home = () => {
  const { user } = useContext(UserContext);
  const [ads, setAds] = useState([]);
  const [filteredAds, setFilteredAds] = useState([]);
  const [userCity, setUserCity] = useState("");
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [enteredCity, setEnteredCity] = useState("");
  const [interests, setInterests] = useState({
    jobs: false,
    services: false,
    events: false,
    offers: false,
    classifieds: false,
  });

  // useEffect(() => {
  //   localStorage.removeItem("hasSeenDialog");
  // }, []);



  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960, // tablet
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const hasSeenDialog = localStorage.getItem("hasSeenDialog");

    if (user && !hasSeenDialog) {
      setOpen(true);
    }

    fetchAds();
  }, [user]);

  // Fetch ads from API
  const fetchAds = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/sponsored-ads`
      );
      if (response.data && Array.isArray(response.data.sponsored_ads)) {
        setAds(response.data.sponsored_ads);
      }
    } catch (error) {
      console.error("Error fetching ads:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch user city if logged in
  useEffect(() => {
    if (user?.id) {
      fetchUserCity(user.id); // Fetch the user's city if logged in
    }
  }, [user]);

  const fetchUserCity = async (userId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/users/${userId}`
      );
      const city = response.data.interested_city;
      if (city) setUserCity(city); // Store the user's city
    } catch (err) {
      console.error("Error fetching user city:", err);
    }
  };

  // Filter ads based on user's city or show all if not logged in
  useEffect(() => {
    fetchAds();
  }, []); // Fetch ads when the component mounts

  useEffect(() => {
    if (userCity && ads.length > 0) {
      const filtered = ads.filter(
        (ad) => ad.location?.toLowerCase() === userCity.toLowerCase()
      );
      setFilteredAds(filtered);
    } else {
      setFilteredAds(ads);
    }
  }, [ads, userCity]);

  const handleInterestChange = (event) => {
    setInterests({
      ...interests,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSave = async () => {
    const payload = {
      city: enteredCity,
      show_jobs: interests.jobs,
      show_services: interests.services,
      show_offers: interests.offers,
      show_events: interests.events,
      show_classifieds: interests.classifieds,
    };

    try {
      if (user?.id) {
        await axios.put(`${API_BASE_URL}/users/${user.id}`, payload); // Send the payload with true/false values
        localStorage.setItem("hasSeenDialog", "true");
        setOpen(false);
      } else {
        console.error("User ID is missing!");
      }
    } catch (error) {
      console.error("🔥 Error saving preferences:", error);
      alert("Failed to save preferences.");
    }
  };

  const handleCancel = () => {
    localStorage.setItem("hasSeenDialog", "true");
    setOpen(false);
  };

  const imageList = [img1, img2, img3, img4, img5, img6];
  const labels = [
    "Sponsored Ads",
    "Jobs",
    "Events",
    "Offers",
    "Classifieds",
    "Services",
  ];

  const videos = ["/videos/Home.mp4"];
  

  return (
    <Box sx={{ backgroundColor: "rgb(255, 255, 255)", pb: 2 }}>
      {/* Dialog */}
      <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Enter Your City
          </Typography>
          <TextField
            fullWidth
            label="City Name"
            variant="outlined"
            value={enteredCity}
            onChange={(e) => setEnteredCity(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Typography variant="subtitle1" gutterBottom>
            You are interested in:
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3 }}>
            {["jobs", "services", "events", "offers", "classifieds"].map(
              (item) => (
                <FormControlLabel
                  key={item}
                  control={
                    <Checkbox
                      checked={interests[item]}
                      onChange={handleInterestChange}
                      name={item}
                    />
                  }
                  label={item.charAt(0).toUpperCase() + item.slice(1)}
                />
              )
            )}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Banner */}
      <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
        <img
          src={bannerpic}
          alt="Banner"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "25%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color:"#42326e",
            fontWeight: "bold",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)",
          }}
        >
          <Typography
            fontWeight="bold"
            color="#42326e"
            sx={{ fontSize: "8rem" }}
          >
            CityZoom
          </Typography>
          <Typography
            color="black"
            sx={{ fontSize: "1.7rem", marginTop: "-30px" }}
          >
            Explore Your City like Never Before
          </Typography>
        </Box>
      </Box>

      <Box id="about" sx={{ py: 6, px: 2, mt: 3 }}>
        {/* About Us Header */}
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          color="#6E5B9A"
          mb={3}
        >
          Get to Know Us
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left Side (Image) */}
          <Box sx={{ flex: 1, mr: 4 }}>
            <img
              src={aboutImage}
              alt="About Us"
              style={{ width: "100%", height: "80%", borderRadius: "10px" }}
            />
          </Box>

          {/* Right Side (Text) */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
              CityZoom is your go-to platform for discovering jobs, services,
              events, and exclusive offers in your area. Whether you're looking
              for career opportunities, exciting local events, or special
              promotions, CityZoom connects you with the best options to fit
              your needs.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
              We strive to create a seamless experience for our users, making it
              easier to find what you're looking for and stay informed.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
              Our platform is designed with the user in mind, ensuring you have
              easy access to everything that matters to you. From personalized
              job recommendations to the latest happenings in your area,
              CityZoom aims to keep you connected with the pulse of your
              community.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
              At CityZoom, we are committed to continuously improving our
              services and expanding our offerings. With a focus on innovation
              and user satisfaction, we aim to be the ultimate guide to help you
              navigate your local area, empowering you to make informed
              decisions every day.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
              Here you can add and find jobs, services, events, offers and
              connect with the people all over the world and get connected with
              them. And also you find all the things which you need.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
              CityZoom is more than just a discovery platform—it's a vibrant
              community that helps you stay connected, informed, and empowered.
              Whether you're exploring local services, posting a job, attending
              events, or taking advantage of special offers. Join CityZoom and
              be part of something local, useful, and dynamic.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Overview of cityzoom */}
      <Container
        id="video-file-preview"
        maxWidth="lg"
        sx={{ mt: 3, mb: 5, pt: 2 }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          color="#6E5B9A"
          mb={3}
        >
          Over View of CityZoom
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {/* Left side - Video */}
          <Grid item xs={12} sm={6}>
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <iframe
                width="100%"
                height="400px"
                src={videos[0]}
                title="CityZoom Demo Video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </Box>
          </Grid>

          {/* Right side - File Preview */}
          <Grid item xs={12} sm={6}>
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <embed
                src={pdfFile}
                type="application/pdf"
                title="File Preview"
                style={{ width: "100%", height: "400px" }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* 🧭 Explore Section */}
      <Container id="explore" maxWidth="lg" sx={{ mt: 3, mb: 5, pt: 2 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          color="#6E5B9A"
          mb={3}
        >
          Explore
        </Typography>
        <Grid container spacing={2}>
          {imageList.map((img, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
              <Box
                component="img"
                src={img}
                alt={`Explore ${index + 1}`}
                sx={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: 2,
                  boxShadow: 3,
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.15)",
                    boxShadow: 6,
                  },
                }}
              />
              <Typography
                variant="subtitle1"
                textAlign="center"
                fontWeight="bold"
                color="#6E5B9A"
                sx={{ fontSize: "1.2rem" }}
                mt={1}
              >
                {labels[index]}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Sponsored Ads */}
      <Container
        id="ads"
        maxWidth="lg"
        sx={{
          mt: 10,
          mb: 5,
          p: 3,
          backgroundColor: "rgb(233, 225, 250)",
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          color="#6E5B9A"
          mb={3}
        >
          Sponsored Ads
        </Typography>

        {loading ? (
          <Box sx={{ textAlign: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : filteredAds.length === 0 ? (
          <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: 2,
            p: 1,
            justifyContent: "center",
          }}
        >
          {[evolve, tracker, easybid].map((img, idx) => (
            <Card
              key={idx}
              sx={{
                minWidth: 300,
                flex: "0 0 auto",
                boxShadow: 3,
              }}
            >
              <CardMedia
                component="img"
                height="200"
                image={img}
                alt={`Sponsored Fallback ${idx}`}
                sx={{ objectFit: "contain" }}
              />
            </Card>
          ))}
        </Box>
        
        ) : (
          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              gap: 2, 
              p: 1,
            }}
          >
            {filteredAds.map((ad, index) => (
              <Card
                key={index}
                sx={{
                  minWidth: 300,
                  flex: "0 0 auto", // prevent shrinking
                  boxShadow: 3,
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={ad.image_url || "https://via.placeholder.com/350"}
                  alt={ad.title}
                  sx={{ objectFit: "contain" }}
                />
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h6" fontWeight="bold" align="center">
                    {ad.title}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <BusinessIcon />
                    <Typography color="textSecondary" sx={{ ml: 1 }}>
                      {ad.business}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <LocationOnIcon />
                    <Typography color="textSecondary" sx={{ ml: 1 }}>
                      {ad.location}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <CurrencyRupeeIcon />
                    <Typography
                      fontWeight="bold"
                      color="primary"
                      sx={{ ml: 1 }}
                    >
                      {ad.price}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Home;
